module.exports = __webpack_public_path__ + "img/graphical_upgrade_after.48d1cf9.png";